import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import classNames from 'classnames';

/* eslint-disable jsx-a11y/alt-text, react/jsx-props-no-spreading */
const Image = ({ lazyload, preload, className, alt, src, ...props }) => {
  const getFinalProps = () => {
    if (!lazyload) {
      return { src, className, alt, ...props };
    }
    return {
      'data-src': src,
      alt,
      className: classNames('lazyload', className),
      ...props,
    };
  };
  const finalProps = getFinalProps();
  return (
    <>
      {preload && (
        <Helmet>
          <link rel="preload" href={src} as="image" />
        </Helmet>
      )}
      <img {...finalProps} />
    </>
  );
};

Image.propTypes = {
  lazyload: PropTypes.bool,
  preload: PropTypes.bool,
  className: PropTypes.string,
  src: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
};

Image.defaultProps = {
  lazyload: false,
  preload: false,
  className: undefined,
};

export default Image;
